import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var templateListRes;
export const templateListTodo = createAsyncThunk('templateList', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'certificate_data_list',
            data: {
                "user_id": id,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return templateListRes = res.data
    } catch (error) {
        return templateListRes = error.response.data
    }
})


const templateListSlice = createSlice({
    name: 'templateList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(templateListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('templateList', state.data)
            }
        });
        builder.addCase(templateListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default templateListSlice.reducer; 